import React from 'react'
import Dashbaord from '../../features/student/Dashboard'

const DashboardPage = () => {
  return <Dashbaord/>
}

export default DashboardPage